import { getResData, httpClient } from "../../utils";
import { CommentDTO, UpdateCommentDTO, UpdateSiteCommentDTO } from "./types";

export const DEFAULT_COMMENTS_PATH = "/comment";
export const SITE_COMMENTS_PATH = "/sitecomment";

export const COMMENTS_API_PATHS = {
  COMMENT: (commentId: number) => `/comment/${commentId}`,
  COMMENT_DONE: (commentId: number) => `/comment/${commentId}/done`,
  COMMENTS_BY_UTILITY_BILL: (utilityBillId: string) => `/comment/bill/${utilityBillId}`,
};

export const SITE_COMMENTS_API_PATHS = {
  SITE_COMMENT_DONE: (commentId: number) => `${SITE_COMMENTS_PATH}/${commentId}/done`,
  ESTIMATE_COMMENTS: (estimateId: string) => `${SITE_COMMENTS_PATH}/estimate/${estimateId}`,
};

export const createComment = (body: UpdateCommentDTO) =>
  httpClient.post(DEFAULT_COMMENTS_PATH, body);

export const markCommentAsDone = (commentId: number) =>
  httpClient.put(COMMENTS_API_PATHS.COMMENT_DONE(commentId));

export const getCommentsByUtilityBill = (utilityBillId: string): Promise<CommentDTO[]> =>
  httpClient.get<CommentDTO[]>(COMMENTS_API_PATHS.COMMENTS_BY_UTILITY_BILL(utilityBillId)).then(getResData);

export const createSiteComment = (body: UpdateSiteCommentDTO) =>
  httpClient.post(SITE_COMMENTS_PATH, body);

export const markSiteCommentAsDone = (commentId: number) =>
  httpClient.put(SITE_COMMENTS_API_PATHS.SITE_COMMENT_DONE(commentId));

export const getCommentsByEstimateId = (estimateId: string): Promise<CommentDTO[]> =>
  httpClient.get<CommentDTO[]>(SITE_COMMENTS_API_PATHS.ESTIMATE_COMMENTS(estimateId)).then(getResData);
